<mat-toolbar color="primary">
  <mat-toolbar-row>
    <span class="nav-spacer"></span>
    <button mat-button style="font-size: 18pt">
      <img *ngIf="LabImg && LabImg != '' " [src]="'data:image/png;base64,'+LabImg"  height="50" style="padding: 5px;"/>
      <span style="padding-left: 5px;">{{fullLabName}}</span>
    </button>
    <span class="nav-spacer"></span>

  </mat-toolbar-row>
</mat-toolbar>

<mat-card  *ngIf="showLockedMessage" style="width: 30vw; margin-right: auto; margin-left: auto; margin-top: 50px;">
  <mat-card-header>
    <mat-card-title>INVALID LINK</mat-card-title>
    <mat-card-subtitle>The Provided link is invalid or has expired. Please contact the requesting agency if you require a new link.</mat-card-subtitle>
  </mat-card-header>
  <mat-card-content style="text-align: center; word-break: break-all">
    For more information about the NIBIN Alert System go to <br /> <a href="https://www.info-cop.com">www.info-cop.com</a> or call 201-935-5090
  </mat-card-content>
</mat-card>

<mat-card  *ngIf="showSavedMessage" style="width: 30vw; margin-right: auto; margin-left: auto; margin-top: 50px;">
  <mat-card-header>
    <mat-card-title>Record Completed</mat-card-title>
    <mat-card-subtitle>The incident record has been submitted for review.</mat-card-subtitle>
  </mat-card-header>
  <mat-card-content style="text-align: center; word-break: break-all">
    For more information about the NIBIN Alert System go to <br /> <a href="https://www.info-cop.com">www.info-cop.com</a> or call 201-935-5090
  </mat-card-content>
</mat-card>


<div class="full" *ngIf="IncidentRecord">

  <div style="font-size:10pt; text-align:center; color:blue; margin:10px;" >
    <span style="border-radius: 10px; border: 2px solid blue;padding: 10px;">
      {{fullLabName}} has requested the following incident be updated with details from your agency case file.
    </span>
  </div>

  <div style="font-size:10pt; color:red; margin:10px; border-radius: 10px; border: 2px solid red;padding: 10px;" *ngIf="ErrList.length>0">
      <ul>
        <li *ngFor="let err of ErrList">{{err}}</li>
      </ul>
  </div>

  <div style="margin: 2em 4em 2em 4em; " *ngIf="SharedEditToken" >
    <div>
      Instructions:
      <ul>
        <li>Yellow & Blue borders indicates MANDATORY fields</li>
        <li>Green borders indicates OPTIONAL but recommended fields</li>
        <li>Review the incident details below.</li>
        <li>When finished, click the "Submit Changes" button to submit your changes.</li>
      </ul>
    </div>
    <app-incident-form [Incident]="IncidentRecord" (IncidentShareEdit)="processSaveReq($event)"></app-incident-form>

    <p style="color: black; background: lightgray; margin: 10px; padding:10px; border: black 2px solid;">
      <span style="font-weight: bold; font-size: 12pt;">(U) INFORMATION NOTICE:</span>
      <span style="font-size: 11pt;"> This product contains unclassified information that is law enforcement sensitive (LES) and for
  official use only (U//FOUO). Recipients should not release any portion of this product to the media, public, or other personnel
  who do not have a valid need-to-know.</span>
    </p>
  </div>


</div>


